var activeToken = {};

export function setActiveToken(token) {
    activeToken = token;
}

export function getActiveToken() {
    return activeToken;
}